import { render, staticRenderFns } from "./general-fields.vue?vue&type=template&id=5284dae1&scoped=true&lang=pug"
import script from "./general-fields.vue?vue&type=script&lang=js"
export * from "./general-fields.vue?vue&type=script&lang=js"
import style0 from "./general-fields.vue?vue&type=style&index=0&id=5284dae1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284dae1",
  null
  
)

export default component.exports